import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DangerAlert from "../child/Alert/DengerAlert"; // corrected typo
import Loader from "../child/Loder";
import { uploadFile } from "../../services/uploadService";
import { Icon } from "@iconify/react/dist/iconify.js";

const AddAccessTypePageNew = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [storageData, setStorageData] = useState([]);
  const [selectedStorageType, setSelectedStorageType] = useState("");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const authToken = localStorage.getItem("authToken");
  const [imagechange, SetImagechnage] = useState(0);

  useEffect(() => {
    const fetchStorageType = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/admin/storageTypeList`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        setStorageData(data.storageTypes || []);
      } catch (error) {
        setErrorMessage("Error fetching storage types");
        clearMessage();
      } finally {
        setLoading(false);
      }
    };

    const fetchSetting = async () => {
      if (!isEditMode) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/admin/accessTypeById/${id}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        if (response.ok) {
          setTitle(data.result.title || "");
          setImagePreview(data.result.image || "");
          setSelectedStorageType(data.result.storagetype._id || "");
        } else {
          setErrorMessage("Error fetching Access Type");
          clearMessage();
        }
      } catch (error) {
        setErrorMessage("Error fetching Access Type");
        clearMessage();
      } finally {
        setLoading(false);
      }
    };

    fetchStorageType();
    fetchSetting();
  }, [id, navigate, authToken, isEditMode]);

  const readURL = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const uploadedProfilePicture = await uploadFile(file);
          setImagePreview(uploadedProfilePicture);
          SetImagechnage(1);
        } catch (error) {
          setErrorMessage("Failed to upload image");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };
  const allowedMimeTypes = ["image/png", "image/jpeg"];
  const validateInputs = () => {
    const newErrors = {};

    if (!title) {
      newErrors.title = "Title is required";
    } else {
      const hasAlphabet = /[A-Za-z]/;
      if (!hasAlphabet.test(title)) {
        newErrors.title =
          "Title cannot be only numbers or only special characters";
      }
      if (title.length < 3) {
        newErrors.title = "Title must be at least 3 characters long";
      }
    }
    if (!selectedStorageType) {
      newErrors.storageType = "Storage Type is required";
    }
    if (imagechange == 0) {
      newErrors.imagePreview = "Access Type image is required.";
    }
    if (imagechange === 1) {
      if (imagePreview) {
        try {
          const url = new URL(imagePreview);
          const pathname = url.pathname;
          const type = pathname.split(".").pop().toLowerCase(); // Ensure it's lowercase
          if (!allowedMimeTypes.includes(`image/${type}`)) {
            newErrors.imagePreview = "Only png and jpg files are allowed.";
          }
        } catch (error) {
          console.error("Invalid URL:", error);
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!validateInputs()) {
      setLoading(false);
      return;
    }
    try {
      const method = isEditMode ? "PUT" : "POST";
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/${isEditMode ? `accessTypeUpdate/${id}` : "accessTypeAdd"}`;
      const trimmedTitle = title.trimEnd();

      const response = await fetch(API_ENDPOINT, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          title: trimmedTitle,
          image: imagePreview,
          status: "active",
          storagetype: selectedStorageType,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        if (
          data.message ===
          "This Access Type already exists under the selected Storage Type."
        ) {
          setErrorMessage("This Access Type already exists.");
          clearMessage();
        } else {
          setSuccessMessage(
            data.message ||
              (isEditMode ? "access type Updated" : "access type Added")
          );
          clearMessage();
          setTimeout(() => navigate("/accesstype"), 3000);
        }
      } else {
        setErrorMessage(data.message || "Something went wrong");
        clearMessage();
      }
    } catch (error) {
      setErrorMessage(error?.message || "Something went wrong");
      clearMessage();
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header"></div>
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DangerAlert message={errorMessage} />}

            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="mb-24 mt-16">
                <h6 className="text-md text-primary-light mb-16">
                  Access Type Image<span className="text-danger-600">*</span>
                </h6>
                <div className="avatar-upload">
                  <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      hidden
                      onChange={(e) => {
                        readURL(e);
                        setErrors((prev) => ({ ...prev, imagePreview: "" }));
                      }}
                    />
                    <label
                      htmlFor="imageUpload"
                      className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                    >
                      <Icon icon="solar:camera-outline" className="icon"></Icon>
                    </label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${imagePreview})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </div>
                </div>
                {errors.imagePreview && (
                  <p className="text-danger mt-1">{errors.imagePreview}</p>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label">
                  Title<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.title ? "is-invalid" : ""}`}
                  id="title"
                  placeholder="Enter title"
                  value={title}
                  minLength="3"
                  maxLength="40"
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setErrors((prev) => ({ ...prev, title: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ")
                      .trimStart();
                  }}
                />
                {errors.title && (
                  <p className="text-danger mt-1">{errors.title}</p>
                )}
              </div>

              <div className="col-md-12">
                <label className="form-label">
                  Select Storage Type<span className="text-danger-600">*</span>
                </label>
                <select
                  className={`form-control ${
                    errors.storageType ? "is-invalid" : ""
                  }`}
                  value={selectedStorageType}
                  onChange={(e) => {
                    setSelectedStorageType(e.target.value);
                    setErrors((prev) => ({ ...prev, storageType: "" }));
                  }}
                  style={{
                    fontSize: "16px",
                    borderRadius: "7px",
                    backgroundPositionX: "unset",
                    backgroundPosition: "right 0.75rem center",
                  }}
                >
                  <option value="">Select Storage Type</option>
                  {storageData.map((st) => (
                    <option key={st._id} value={st._id}>
                      {st.title}
                    </option>
                  ))}
                </select>
                {errors.storageType && (
                  <p className="text-danger mt-1">{errors.storageType}</p>
                )}
              </div>

              <div className="col-12">
                <button
                  className="btn btn-primary mt-3 float-end"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAccessTypePageNew;
